import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  APP_INITIALIZER,
  ErrorHandler,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { routes } from './app.routes';
import { GlobalErrorHandler } from './core/error-handler/global-error-handler';
import { csrfInterceptor } from './core/interceptors/csrf.interceptor';
import { environment } from '../environments/environment';

// Initialize Firebase app
const app = initializeApp(environment.firebase);

// Create provider functions to ensure they are executed
const firebaseAppProvider = provideFirebaseApp(() => app);
const authProvider = provideAuth(() => getAuth(app));
const firestoreProvider = provideFirestore(() => getFirestore(app));
const storageProvider = provideStorage(() => getStorage(app));

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withInterceptors([csrfInterceptor])),
    firebaseAppProvider,
    authProvider,
    firestoreProvider,
    storageProvider,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
};
